export const files = new Map([[".editorconfig", {
  "type": "base64",
  "body": "cm9vdCA9IHRydWUKClsqXQplbmRfb2ZfbGluZSA9IGxmCmluc2VydF9maW5hbF9uZXdsaW5lID0gdHJ1ZQp0cmltX3RyYWlsaW5nX3doaXRlc3BhY2UgPSB0cnVlCmNoYXJzZXQgPSB1dGYtOAppbmRlbnRfc3R5bGUgPSBzcGFjZQppbmRlbnRfc2l6ZSA9IDIK"
}], [".vscode/extensions.json", {
  "type": "base64",
  "body": "ewogICJyZWNvbW1lbmRhdGlvbnMiOiBbCiAgICAiZGJhZXVtZXIudnNjb2RlLWVzbGludCIsCiAgICAiZXNiZW5wLnByZXR0aWVyLXZzY29kZSIsCiAgICAiZWRpdG9yY29uZmlnLmVkaXRvcmNvbmZpZyIKICBdCn0K"
}], [".vscode/settings.json", {
  "type": "base64",
  "body": "ewogICJlZGl0b3IuZm9ybWF0T25TYXZlIjogdHJ1ZSwKICAiZWRpdG9yLmRlZmF1bHRGb3JtYXR0ZXIiOiAiZXNiZW5wLnByZXR0aWVyLXZzY29kZSIsCiAgImVzbGludC51c2VGbGF0Q29uZmlnIjogdHJ1ZSwKICAic2VhcmNoLmV4Y2x1ZGUiOiB7CiAgICAiKiovbm9kZV9tb2R1bGVzIjogdHJ1ZSwKICAgICIqKi9kaXN0IjogdHJ1ZQogIH0KfQo="
}], [".gitignore", {
  type: "raw",
  body: `# Logs
logs
*.log
npm-debug.log*
yarn-debug.log*
yarn-error.log*
pnpm-debug.log*
lerna-debug.log*

node_modules
dist
dist-ssr
*.local
.pnpm-store

# Editor directories and files
.vscode/*
!.vscode/extensions.json
!.vscode/settings.json
.idea
.DS_Store
*.suo
*.ntvs*
*.njsproj
*.sln
*.sw?
`
}], ["eslint.config.mjs", {
  "type": "base64",
  "body": "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"
}], ["prettier.config.js", {
  "type": "base64",
  "body": "ZXhwb3J0IGRlZmF1bHQgewogIHNlbWk6IHRydWUsCiAgc2luZ2xlUXVvdGU6IGZhbHNlLAogIHRyYWlsaW5nQ29tbWE6ICJhbGwiLAogIHByaW50V2lkdGg6IDEwMCwKICB0YWJXaWR0aDogMiwKICBwbHVnaW5zOiBbIkB0cml2YWdvL3ByZXR0aWVyLXBsdWdpbi1zb3J0LWltcG9ydHMiXSwKICBpbXBvcnRPcmRlcjogWwogICAgIl5yZWFjdCIsCiAgICAiXkBvc2RrLyguKikkIiwKICAgICI8VEhJUkRfUEFSVFlfTU9EVUxFUz4iLAogICAgIl5ALyguKikkIiwKICAgICJeWy4vXSIsCiAgXSwKICBpbXBvcnRPcmRlclNlcGFyYXRpb246IGZhbHNlLAogIGltcG9ydE9yZGVyU29ydFNwZWNpZmllcnM6IHRydWUsCn07Cg=="
}], ["public/palantir.svg", {
  "type": "base64",
  "body": "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjEwNzY4IDYuMDY0MDFDNC4xMDc2OCA4LjM3NzEgNS45NjcwMiAxMC4yNTI2IDguMjYwNTkgMTAuMjUyNkMxMC41NTQzIDEwLjI1MjYgMTIuNDEzOCA4LjM3NzEgMTIuNDEzOCA2LjA2NDAxQzEyLjQxMzggMy43NTA4IDEwLjU1NDMgMS44NzU1MyA4LjI2MDU5IDEuODc1NTNDNS45NjcwMiAxLjg3NTUzIDQuMTA3NjggMy43NTA4IDQuMTA3NjggNi4wNjQwMVpNOC4yNjA5MyAxMy45MjNMMTMuNjI5OSAxMS41ODQ4TDE0LjUyMTcgMTMuMzA5MUw4LjI2MDkzIDE2TDIgMTMuMzA5MUwyLjg5MjAxIDExLjU4NDhMOC4yNjA5MyAxMy45MjNaTTguMjYxMDEgMEM0Ljk0MzY3IDAgMi4yNTQ0MiAyLjcxMjI4IDIuMjU0NDIgNi4wNTgwM0MyLjI1NDQyIDkuNDAzNzggNC45NDM2NyAxMi4xMTU5IDguMjYxMDEgMTIuMTE1OUMxMS41NzgyIDEyLjExNTkgMTQuMjY3NiA5LjQwMzc4IDE0LjI2NzYgNi4wNTgwM0MxNC4yNjc2IDIuNzEyMjggMTEuNTc4MiAwIDguMjYxMDEgMFoiIGZpbGw9IiMxMTE0MTgiLz4KPC9zdmc+Cg=="
}], ["public/react.svg", {
  "type": "base64",
  "body": "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"
}], ["src/Home.module.css", {
  "type": "base64",
  "body": "LmhvbWUgewogIGRpc3BsYXk6IGZsZXg7CiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjsKICBnYXA6IGNhbGModmFyKC0tYnAtc3VyZmFjZS1zcGFjaW5nKSAqIDE1KTsKICBtYXgtd2lkdGg6IDgwMHB4OwogIHdpZHRoOiAxMDAlOwp9Cg=="
}], ["src/Home.tsx.hbs", {
  type: "raw",
  body: `import React from "react";
{{#if osdkPackage}}
// import { useOsdkClient } from "@osdk/react";
{{/if}}
import css from "./Home.module.css";
import Header from "@/components/Header";
import NextSteps from "@/components/NextSteps";
{{#if osdkPackage}}
import Osdk from "@/components/Osdk";
{{/if}}

function Home(): React.ReactElement {
  {{#if osdkPackage}}
  // See Ontology and Platform SDK docs in Developer Console on how to
  // use the client object to access Ontology resources and platform APIs
  // const client = useOsdkClient();

  {{/if}}
  return (
    <div className={css.home}>
      <Header />
      {{#if osdkPackage}}
      <Osdk />
      {{/if}}
      <NextSteps />
    </div>
  );
}

export default Home;
`
}], ["src/components/ErrorBoundary.module.css", {
  "type": "base64",
  "body": "LmNvbnRhaW5lciB7CiAgcGFkZGluZzogMnJlbTsKICB0ZXh0LWFsaWduOiBjZW50ZXI7Cn0KCi5tZXNzYWdlIHsKICBjb2xvcjogIzVmNmI3YzsKfQoKLnJldHJ5QnV0dG9uIHsKICBtYXJnaW4tdG9wOiAxcmVtOwogIHBhZGRpbmc6IDhweCAxNnB4OwogIGJvcmRlcjogMXB4IHNvbGlkICNlMWU0ZTg7CiAgYm9yZGVyLXJhZGl1czogNHB4OwogIGJhY2tncm91bmQ6ICNmZmY7CiAgY3Vyc29yOiBwb2ludGVyOwp9Cg=="
}], ["src/components/ErrorBoundary.tsx", {
  type: "raw",
  body: `import React from "react";
import css from "./ErrorBoundary.module.css";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

class ErrorBoundary
  extends React.Component<ErrorBoundaryProps, ErrorBoundaryState>
{
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  render(): React.ReactNode {
    if (this.state.error) {
      return (
        <div className={css.container}>
          <h2>Something went wrong</h2>
          <p className={css.message}>{this.state.error.message}</p>
          <button
            className={css.retryButton}
            onClick={() => this.setState({ error: null })}
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
`
}], ["src/components/Header.module.css", {
  "type": "base64",
  "body": "LmhlYWRlckNvbnRhaW5lciB7CiAgYWxpZ24taXRlbXM6IGNlbnRlcjsKICBkaXNwbGF5OiBmbGV4OwogIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47CiAgZ2FwOiBjYWxjKHZhcigtLWJwLXN1cmZhY2Utc3BhY2luZykgKiAxMCk7Cn0KCi5oZWFkZXIgewogIG1hcmdpbjogMDsKICB0ZXh0LWFsaWduOiBjZW50ZXI7Cn0KCi5sb2dvcyB7CiAgZGlzcGxheTogZmxleDsKICBnYXA6IGNhbGModmFyKC0tYnAtc3VyZmFjZS1zcGFjaW5nKSAqIDgpOwp9CgoubG9nbyB7CiAgaGVpZ2h0OiA0OHB4OwogIHRyYW5zaXRpb246IGZpbHRlciAzMDBtczsKICB3aWxsLWNoYW5nZTogZmlsdGVyOwp9CgoubG9nbzpob3ZlciB7CiAgZmlsdGVyOiBkcm9wLXNoYWRvdygwIDAgMmVtICM2NDZjZmZhYSk7Cn0K"
}], ["src/components/Header.tsx", {
  type: "raw",
  body: `import palantir from "/palantir.svg";
import react from "/react.svg";

import { H2, Link } from "@blueprintjs/core";
import React from "react";
import css from "./Header.module.css";

function Header(): React.ReactElement {
  return (
    <header className={css.headerContainer}>
      <div className={css.logos}>
        <Link
          href="https://www.palantir.com/docs/foundry/ontology-sdk/overview/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={palantir} className={css.logo} alt="Palantir logo" />
        </Link>
        <Link href="https://react.dev" target="_blank" rel="noreferrer">
          <img src={react} className={css.logo} alt="React logo" />
        </Link>
      </div>
      <H2 className={css.header}>Build your React application with Foundry!</H2>
    </header>
  );
}

export default Header;
`
}], ["src/components/Loading.tsx", {
  type: "raw",
  body: `import React from "react";

function Loading(): React.ReactElement {
  return (
    <div style={{ padding: "2rem", textAlign: "center", color: "#5f6b7c" }}>
      Loading...
    </div>
  );
}

export default Loading;
`
}], ["src/components/NextSteps.module.css", {
  "type": "base64",
  "body": "Lm5leHRTdGVwcyB7CiAgZGlzcGxheTogZmxleDsKICBmbGV4LWRpcmVjdGlvbjogY29sdW1uOwogIGdhcDogY2FsYyh2YXIoLS1icC1zdXJmYWNlLXNwYWNpbmcpICogNCk7Cn0KCi5uZXh0U3RlcHNIZWFkZXIgewogIGFsaWduLXNlbGY6IGJhc2VsaW5lOwogIGZvbnQtd2VpZ2h0OiA2MDA7CiAgbWFyZ2luOiAwOwp9CgoubmV4dFN0ZXAgewogIGJvcmRlcjogMXB4IHNvbGlkICMxMTE0MTgyNjsKICBib3JkZXItcmFkaXVzOiB2YXIoLS1icC1zdXJmYWNlLWJvcmRlci1yYWRpdXMpOwogIGRpc3BsYXk6IGZsZXg7CiAgZ2FwOiBjYWxjKHZhcigtLWJwLXN1cmZhY2Utc3BhY2luZykgKiAzKTsKICBwYWRkaW5nOiBjYWxjKHZhcigtLWJwLXN1cmZhY2Utc3BhY2luZykgKiA0KTsKfQoKLm5leHRTdGVwQ29udGVudCB7CiAgZGlzcGxheTogZmxleDsKICBmbGV4LWRpcmVjdGlvbjogY29sdW1uOwogIHRleHQtYWxpZ246IGxlZnQ7Cn0KCi50aXRsZSB7CiAgZm9udC13ZWlnaHQ6IDYwMDsKICBtYXJnaW46IDA7Cn0KCi5zdWJ0aXRsZSB7CiAgY29sb3I6IHZhcigtLWJwLXR5cG9ncmFwaHktY29sb3ItbXV0ZWQpOwp9CgoubXV0ZWQgewogIGNvbG9yOiB2YXIoLS1icC10eXBvZ3JhcGh5LWNvbG9yLW11dGVkKTsKfQoKLmljb24gewogIGFsaWduLWl0ZW1zOiBjZW50ZXI7CiAgYmFja2dyb3VuZC1jb2xvcjogb2tsY2goZnJvbSB2YXIoLS1icC1pbnRlbnQtZGVmYXVsdC1yZXN0KSBsIGMgaCAvIDE1JSk7CiAgYm9yZGVyOiB2YXIoLS1icC1zdXJmYWNlLWJvcmRlci13aWR0aCkgc29saWQKICAgIHZhcigtLWJwLXN1cmZhY2UtYm9yZGVyLWNvbG9yLWRlZmF1bHQpOwogIGJvcmRlci1yYWRpdXM6IDMwcHg7CiAgY29sb3I6IHZhcigtLWJwLWludGVudC1kZWZhdWx0LXJlc3QpOwogIGRpc3BsYXk6IGZsZXg7CiAgaGVpZ2h0OiAzNHB4OwogIGp1c3RpZnktY29udGVudDogY2VudGVyOwogIHBhZGRpbmc6IGNhbGModmFyKC0tYnAtc3VyZmFjZS1zcGFjaW5nKSAqIDIpOwogIHdpZHRoOiAzNHB4Owp9Cg=="
}], ["src/components/NextSteps.tsx.hbs", {
  type: "raw",
  body: `import { Code, H5, H6, Icon, Link, Text } from "@blueprintjs/core";
import { type IconName } from "@blueprintjs/icons";
import React from "react";
import css from "./NextSteps.module.css";

const STEPS: INextStep[] = [
  {{^if osdkPackage}}
  {
    icon: "cube",
    title: "Configure your Ontology and Platform SDKs",
    subtitle: (
      <span>
        Use the Ontology SDK to interact with your Ontology and the Platform SDK
        to access Foundry APIs. Configure your SDKs from the{" "}
        <strong>Ontology SDK</strong> and <strong>Platform SDK</strong> tabs in
        Developer Console.
      </span>
    ),
  },
  {{/if}}
  {
    icon: "group-item",
    title: (
      <span>
        Develop with OSDK React components{" "}
        <span className={css.muted}>(Optional)</span>
      </span>
    ),
    subtitle: (
      <span>
        Use <Link
          href="https://palantir.github.io/osdk-ts/storybook/"
          target="_blank"
          rel="noreferrer"
        >
          OSDK React components
        </Link>{" "}
        (@osdk/react-components){" "}
        to build your app with ready-made Ontology SDK components.
      </span>
    ),
  },
  {{^if applicationUrl}}
  {
    icon: "cloud",
    title: "Request a subdomain to host your application with Foundry",
    subtitle: (
      <span>
        Register a subdomain for your website on the{" "}
        <strong>Website hosting</strong> tab in Developer Console. Then, add
        this subdomain to your redirect URLs on the{" "}
        <strong>OAuth & scopes</strong> tab and update your{" "}
        <Code>.env.production</Code> file.
      </span>
    ),
  },
  {{/if}}
  {
    icon: "rocket-slant",
    title: "Deploy your application",
    subtitle: (
      <span>
        To deploy a new version of your application, tag a new version of your
        repository or use the command line to run{" "}
        <Code>npx @osdk/cli@latest site deploy</Code>.{" "}
        <Link
          href="https://www.npmjs.com/package/@osdk/cli"
          target="_blank"
          rel="noreferrer"
        >
          Learn more.
        </Link>
      </span>
    ),
  },
];

function NextSteps(): React.ReactElement {
  return (
    <div className={css.nextSteps}>
      <H5 className={css.nextStepsHeader}>Next steps</H5>
      {STEPS.map((step, index) => (
        <NextStep
          key={index}
          icon={step.icon}
          title={step.title}
          subtitle={step.subtitle}
        />
      ))}
    </div>
  );
}

interface INextStep {
  icon: IconName;
  title: React.ReactNode;
  subtitle: React.ReactElement;
}

function NextStep({ icon, title, subtitle }: INextStep): React.ReactElement {
  return (
    <div className={css.nextStep}>
      <div className={css.icon}>
        <Icon icon={icon} aria-label={icon} />
      </div>
      <div className={css.nextStepContent}>
        <H6 className={css.title}>{title}</H6>
        <Text className={css.subtitle}>{subtitle}</Text>
      </div>
    </div>
  );
}

export default NextSteps;
`
}], ["src/components/Osdk.module.osdk.css", {
  "type": "base64",
  "body": "Lm9zZGsgewogIGFsaWduLXNlbGY6IGJhc2VsaW5lOwogIGFsaWduLWl0ZW1zOiBjZW50ZXI7CiAgZGlzcGxheTogZmxleDsKICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47CiAgbWF4LXdpZHRoOiA4MDBweDsKICB3aWR0aDogMTAwJTsKfQo="
}], ["src/components/Osdk.tsx.osdk.hbs", {
  type: "raw",
  body: `import { AnchorButton, Icon, Tag } from "@blueprintjs/core";
import React from "react";
import css from "./Osdk.module.css";

const DOCUMENTATION_URL =
  "{{foundryUrl}}/workspace/developer-console/app/{{application}}/docs/guide/loading-data?language=typescript";

function Osdk(): React.ReactElement {
  return (
    <div className={css.osdk}>
      <div>
        <span>OSDK: </span>
        <Tag minimal={true}>{{osdkPackage}}</Tag>
      </div>
      <AnchorButton
        href={DOCUMENTATION_URL}
        target="_blank"
        rel="noreferrer"
        variant="minimal"
        icon={<Icon icon="book" aria-label="Book icon"></Icon>}
      >
        View documentation
      </AnchorButton>
    </div>
  );
}

export default Osdk;
`
}], ["src/index.css", {
  "type": "base64",
  "body": "LyogQmx1ZXByaW50SlMgKi8KQGltcG9ydCAibm9ybWFsaXplLmNzcyI7CkBpbXBvcnQgIkBibHVlcHJpbnRqcy9jb3JlL2xpYi9jc3MvYmx1ZXByaW50LmNzcyI7CkBpbXBvcnQgIkBibHVlcHJpbnRqcy9pY29ucy9saWIvY3NzL2JsdWVwcmludC1pY29ucy5jc3MiOwoKOnJvb3QgewogIGZvbnQtZmFtaWx5OgogICAgIlNvdXJjZSBTYW5zIFBybyIsIHN5c3RlbS11aSwgQXZlbmlyLCBIZWx2ZXRpY2EsIEFyaWFsLCBzYW5zLXNlcmlmOwogIGZvbnQtc3ludGhlc2lzOiBub25lOwogIHRleHQtcmVuZGVyaW5nOiBvcHRpbWl6ZUxlZ2liaWxpdHk7CiAgLXdlYmtpdC1mb250LXNtb290aGluZzogYW50aWFsaWFzZWQ7CiAgLW1vei1vc3gtZm9udC1zbW9vdGhpbmc6IGdyYXlzY2FsZTsKfQoKI3Jvb3QtY29udGFpbmVyIHsKICBhbGlnbi1pdGVtczogY2VudGVyOwogIGRpc3BsYXk6IGZsZXg7CiAgZmxleDogMTsKfQoKI3Jvb3QgewogIG1hcmdpbjogMCBhdXRvOwogIG1heC13aWR0aDogMTI4MHB4OwogIHBhZGRpbmc6IGNhbGModmFyKC0tYnAtc3VyZmFjZS1zcGFjaW5nKSAqIDgpOwp9Cgpib2R5IHsKICBkaXNwbGF5OiBmbGV4OwogIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47CiAgbWFyZ2luOiAwOwogIG1pbi1oZWlnaHQ6IDEwMHZoOwp9Cg=="
}], ["src/main.tsx.hbs", {
  type: "raw",
  body: `import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
{{#if osdkPackage}}
import { OsdkProvider } from "@osdk/react";
import client from "@/client";
{{/if}}
import ErrorBoundary from "@/components/ErrorBoundary";
import Loading from "@/components/Loading";
import { router } from "@/router";
import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

ReactDOM.createRoot(rootElement).render(
  <ErrorBoundary>
    <Suspense fallback={<Loading />}>
      {{#if osdkPackage}}
      <OsdkProvider client={client}>
        <RouterProvider router={router} />
      </OsdkProvider>
      {{else}}
      <RouterProvider router={router} />
      {{/if}}
    </Suspense>
  </ErrorBoundary>,
);
`
}], ["src/vite-env.d.ts", {
  "type": "base64",
  "body": "Ly8vIDxyZWZlcmVuY2UgdHlwZXM9InZpdGUvY2xpZW50IiAvPgo="
}], ["tsconfig.json", {
  "type": "base64",
  "body": "ewogICJjb21waWxlck9wdGlvbnMiOiB7CiAgICAidGFyZ2V0IjogIkVTMjAyMCIsCiAgICAidXNlRGVmaW5lRm9yQ2xhc3NGaWVsZHMiOiB0cnVlLAogICAgImxpYiI6IFsiRVMyMDIwIiwgIkRPTSIsICJET00uSXRlcmFibGUiXSwKICAgICJtb2R1bGUiOiAiRVNOZXh0IiwKICAgICJza2lwTGliQ2hlY2siOiB0cnVlLAoKICAgIC8qIEJ1bmRsZXIgbW9kZSAqLwogICAgIm1vZHVsZVJlc29sdXRpb24iOiAiYnVuZGxlciIsCiAgICAiYWxsb3dJbXBvcnRpbmdUc0V4dGVuc2lvbnMiOiB0cnVlLAogICAgInJlc29sdmVKc29uTW9kdWxlIjogdHJ1ZSwKICAgICJpc29sYXRlZE1vZHVsZXMiOiB0cnVlLAogICAgIm5vRW1pdCI6IHRydWUsCiAgICAianN4IjogInJlYWN0LWpzeCIsCgogICAgLyogTGludGluZyAqLwogICAgInN0cmljdCI6IHRydWUsCiAgICAibm9VbnVzZWRMb2NhbHMiOiB0cnVlLAogICAgIm5vVW51c2VkUGFyYW1ldGVycyI6IHRydWUsCiAgICAibm9GYWxsdGhyb3VnaENhc2VzSW5Td2l0Y2giOiB0cnVlLAoKICAgIC8qIFBhdGggYWxpYXNlcyAqLwogICAgImJhc2VVcmwiOiAiLiIsCiAgICAicGF0aHMiOiB7CiAgICAgICJALyoiOiBbIi4vc3JjLyoiXQogICAgfQogIH0sCiAgImluY2x1ZGUiOiBbInNyYyJdLAogICJyZWZlcmVuY2VzIjogW3sgInBhdGgiOiAiLi90c2NvbmZpZy5ub2RlLmpzb24iIH1dCn0K"
}], ["tsconfig.node.json", {
  "type": "base64",
  "body": "ewogICJjb21waWxlck9wdGlvbnMiOiB7CiAgICAiY29tcG9zaXRlIjogdHJ1ZSwKICAgICJza2lwTGliQ2hlY2siOiB0cnVlLAogICAgIm1vZHVsZSI6ICJFU05leHQiLAogICAgIm1vZHVsZVJlc29sdXRpb24iOiAiYnVuZGxlciIsCiAgICAiYWxsb3dTeW50aGV0aWNEZWZhdWx0SW1wb3J0cyI6IHRydWUKICB9LAogICJpbmNsdWRlIjogWyJ2aXRlLmNvbmZpZy50cyJdCn0K"
}], ["README.md.hbs", {
  type: "raw",
  body: `# {{project}}

{{#if osdkPackage}}
This project was generated with [\`@osdk/create-app\`](https://www.npmjs.com/package/@osdk/create-app) in authless mode and demonstrates using the Ontology SDK package \`{{osdkPackage}}\` with React on top of Vite. Check out the [Vite](https://vitejs.dev/guide/) docs for further configuration.
{{else}}
This project was generated with [\`@osdk/create-app\`](https://www.npmjs.com/package/@osdk/create-app) in authless mode and demonstrates using the Platform SDK with React on top of Vite. Check out the [Vite](https://vitejs.dev/guide/) docs for further configuration.
{{/if}}

## Developing

Run the following command or equivalent with your preferred package manager to start a local development server on \`http://localhost:8080\`:

\`\`\`sh
npm run dev
\`\`\`

Development configuration is stored in \`.env.development\`.

A proxy is configured in \`vite.config.ts\` that forwards API requests through \`/api-proxy\` to Foundry's \`/proxy\` endpoint. This avoids CORS issues during local development.

## Deploying

Run the following command or equivalent with your preferred package manager to create a production build of your application:

\`\`\`sh
npm run build
\`\`\`

Production configuration is stored in \`.env.production\`. Update the \`VITE_FOUNDRY_API_URL\` to point to your application's subdomain proxy URL.

A \`foundry.config.json\` file is included in the root of this project to make deploying to Foundry website hosting with [\`@osdk/cli\`](https://www.npmjs.com/package/@osdk/cli) easier. If you are not using Foundry website hosting for your application you may delete this file.
`
}], ["index.html.hbs", {
  type: "raw",
  body: `<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <link rel="icon" type="image/svg+xml" href="/react.svg" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="osdk-foundryUrl" content="%VITE_FOUNDRY_API_URL%" />
    {{#if osdkPackage}}
    <meta name="osdk-ontologyRid" content="%VITE_FOUNDRY_ONTOLOGY_RID%" />
    <title>Ontology SDK + React</title>
    {{else}}
    <title>Platform SDK + React</title>
    {{/if}}
  </head>
  <body>
    <div id="root-container">
      <div id="root"></div>
    </div>
    <script type="module" src="/src/main.tsx"></script>
  </body>
</html>
`
}], ["package.json.osdk.hbs", {
  type: "raw",
  body: `{
  "name": "{{project}}",
  "private": true,
  "version": "0.0.0",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "tsc && vite build",
    "format": "prettier --write src/",
    "lint": "eslint . --report-unused-disable-directives --max-warnings 0",
    "lint:fix": "eslint --report-unused-disable-directives --max-warnings 0 --fix",
    "typecheck": "tsc --noEmit",
    "test": "vitest run",
    "preview": "vite preview"
  },
  "dependencies": {
    "{{osdkPackage}}": "latest",
    "@osdk/client": "{{clientVersion}}",
    "@osdk/foundry": "latest",
    "@osdk/oauth": "^1.10.0",
    "@osdk/react": "{{clientVersion}}",
    "@blueprintjs/core": "^6.10.0",
    "@blueprintjs/icons": "^6.7.0",
    "normalize.css": "^8.0.1",
    "react": "^18",
    "react-dom": "^18",
    "react-router-dom": "^6.30.1"
  },
  "devDependencies": {
    "@trivago/prettier-plugin-sort-imports": "^5.0.0",
    "prettier": "^3.0.0",
    "@eslint/compat": "^1.3.2",
    "@eslint/js": "^9.35.0",
    "@types/eslint-plugin-jsx-a11y": "^6.10.0",
    "@types/node": "^24.12.0",
    "@types/react": "^18",
    "@types/react-dom": "^18",
    "@typescript-eslint/eslint-plugin": "^8.43.0",
    "@typescript-eslint/parser": "^8.43.0",
    "@vitejs/plugin-react": "^4.7.0",
    "eslint": "^9.35.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^5.2.0",
    "eslint-plugin-react-refresh": "^0.4.20",
    "globals": "^15.15.0",
    "typescript": "~5.5.4",
    "typescript-eslint": "^8.43.0",
    "vite": "^7.3.1",
    "vitest": "^3.2.4"
  }
}`
}], ["package.json.psdk.hbs", {
  type: "raw",
  body: `{
  "name": "{{project}}",
  "private": true,
  "version": "0.0.0",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "tsc && vite build",
    "format": "prettier --write src/",
    "lint": "eslint . --report-unused-disable-directives --max-warnings 0",
    "lint:fix": "eslint --report-unused-disable-directives --max-warnings 0 --fix",
    "typecheck": "tsc --noEmit",
    "test": "vitest run",
    "preview": "vite preview"
  },
  "dependencies": {
    "@osdk/client": "{{clientVersion}}",
    "@osdk/foundry": "latest",
    "@osdk/oauth": "^1.10.0",
    "@blueprintjs/core": "^6.10.0",
    "@blueprintjs/icons": "^6.7.0",
    "normalize.css": "^8.0.1",
    "react": "^18",
    "react-dom": "^18",
    "react-router-dom": "^6.30.1"
  },
  "devDependencies": {
    "@trivago/prettier-plugin-sort-imports": "^5.0.0",
    "prettier": "^3.0.0",
    "@eslint/compat": "^1.3.2",
    "@eslint/js": "^9.35.0",
    "@types/eslint-plugin-jsx-a11y": "^6.10.0",
    "@types/node": "^24.12.0",
    "@types/react": "^18",
    "@types/react-dom": "^18",
    "@typescript-eslint/eslint-plugin": "^8.43.0",
    "@typescript-eslint/parser": "^8.43.0",
    "@vitejs/plugin-react": "^4.7.0",
    "eslint": "^9.35.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^5.2.0",
    "eslint-plugin-react-refresh": "^0.4.20",
    "globals": "^15.15.0",
    "typescript": "~5.5.4",
    "typescript-eslint": "^8.43.0",
    "vite": "^7.3.1",
    "vitest": "^3.2.4"
  }
}`
}], ["src/client.ts.hbs", {
  type: "raw",
  body: `{{#if osdkPackage}}
import { createClient, type Client } from "@osdk/client";
{{else}}
import { createPlatformClient, type PlatformClient } from "@osdk/client";
{{/if}}
import { createAuthlessClient } from "@osdk/oauth";

const foundryUrl = import.meta.env.VITE_FOUNDRY_API_URL;
{{#if osdkPackage}}
const ontologyRid = import.meta.env.VITE_FOUNDRY_ONTOLOGY_RID;
{{/if}}

{{#if osdkPackage}}
/**
 * Initialize the client to interact with the Ontology and Platform SDKs
 */
export const client: Client = createClient(foundryUrl, ontologyRid, createAuthlessClient());
{{else}}
/**
 * Initialize the client to interact with the Platform SDK
 */
export const client: PlatformClient = createPlatformClient(foundryUrl, createAuthlessClient());
{{/if}}

export default client;
`
}], ["src/env.test.ts.hbs", {
  type: "raw",
  body: `import { loadEnv } from "vite";
import { expect, test } from "vitest";

const ENV_VARS = [
  "VITE_FOUNDRY_API_URL",
];

for (const envVar of ENV_VARS) {
  test.skipIf(process.env.VERIFY_ENV_PRODUCTION !== "true")(
    \`production env should contain \${envVar}\`,
    () => {
      const env = loadEnv("production", process.cwd());
      expect(env[envVar], \`\${envVar} should be defined\`).toBeDefined();
      expect(
        env[envVar],
        \`\${envVar} should not contain placeholder value\`,
      ).not.toMatch(/<.*>/);
    },
  );
}
`
}], ["src/router.tsx.hbs", {
  type: "raw",
  body: `import Home from "@/Home";
import { createBrowserRouter } from "react-router-dom";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Home />,
    },
  ],
  { basename: import.meta.env.BASE_URL },
);
`
}], ["vite.config.ts.hbs", {
  type: "raw",
  body: `import path from "node:path";
import react from "@vitejs/plugin-react";
import { defineConfig } from "vite";

// https://vitejs.dev/config/
export default defineConfig(({ mode }) => {
  return {
    plugins: [react()],
    resolve: {
      alias: {
        "@": path.resolve(__dirname, "./src"),
      },
    },
    server: {
      port: 8080,
      proxy: {
        "^/.*api-proxy.*": {
          target: "{{applicationUrl}}",
          changeOrigin: true,
          secure: true,
          rewrite: (path) => {
            const match = path.match(/\\/api-proxy(.*)\$/);
            if (match) {
              return \`/proxy\${match[1]}\`;
            }
            return path;
          },
        },
      },
    },
    define: {
      "process.env.NODE_ENV": JSON.stringify(mode),
    },
  };
});
`
}]]);